//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useContext} from 'react';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { SchedulerProvider } from './components/SchedulerContext/SchedulerContext' ;
import { ControlBox        } from './components/SchedulerControlBox/ControlBox'    ;
import { SchedulerTable    } from './components/SchedulerTable/SchedulerTable'     ;
import { AppContext        } from 'pages/App/components/AppContext/AppContext';

//#endregion

//-----------------------------------------------------------------
export function SchedulerPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { user_details } = useContext( AppContext );
  
  const theme        = useTheme();
  const navigate     = useNavigate();

  const hasPermission = user_details.roles?.some((item) => item.RoleName === 'reporter');
 
  let page = localStorage.getItem('display_page');
  if( !page ) page = 'verify';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      backgroundColor: 'var(--bg-color-secondary)',
      padding: '1rem',
      width: '100%',
      display: 'inline-block',
    }
  }

  // === ATTRIBUTES ===
  const
    CONTAINER = {
      sx: _styles.container,
    };


  //#endregion

  //#region [green] Events

  if( user_details.roles.length === 0 ) {
    return null;
  }

  if( !hasPermission ) {
    navigate( '/' + page );    
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <SchedulerProvider>
          <ControlBox     />
          <SchedulerTable />
        </SchedulerProvider>
      </Box>
    );
  }

  //#endregion

  return display();
}
